import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { OrganizationSettings } from '@paragon/contract-library';

type OrganizationSettingsState = Record<string, OrganizationSettings>;

const initialState: OrganizationSettingsState = {};

const organizationSettingsSlice = createSlice({
  name: 'organizationSettings',
  initialState,
  reducers: {
    organizationSettingsUpsert: (state, action: PayloadAction<OrganizationSettings>) => {
      state[action.payload.organization] = castDraft(action.payload);
    },
    organizationSettingsSet: (state, action: PayloadAction<OrganizationSettings[]>) => {
      action.payload.forEach((settings) => {
        state[settings.organization] = castDraft(settings);
      });
    },
  },
});

export const { organizationSettingsUpsert, organizationSettingsSet } = organizationSettingsSlice.actions;
export const organizationSettings = organizationSettingsSlice.reducer;
